import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Import console utilities
import './utils/repairEmbeddings.ts'

createRoot(document.getElementById("root")!).render(<App />);
